import useViewReport from './UseViewReport';

import PopUpModal from '../dialogs/PopUpModal';

import style from './ViewReport.module.css';

const ViewReport = ({ reportInfoId, reportParameters, onBackToGrid }) => {
  const {
    frameId,
    title,
    src,
    containerStyle } = useViewReport(reportInfoId, reportParameters);

  return (
    <PopUpModal
      className={`${style.PopUpModalMargin} ${style.reportModalTop}`}
      widthPct={98}
      maxWidth={2560}
      title={title}
      displayPopUp={true}
      onModalCanceled={onBackToGrid}>
      <div className={style.reportContent}>
        <div className={style.reportBody}>
          {src && (
            <div className={style.iframeHost}>
              <iframe
                id={frameId}
                title={title}
                className={style.iframeFill}
                style={containerStyle}
                src={src}
              />
            </div>
          )}
        </div>
      </div>
    </PopUpModal>
  );
};

export default ViewReport;